<script setup>
import { defineProps, ref, watch, computed } from 'vue';

const props = defineProps({
    activeSkuProduct: {
        type: Object,
        default: () => {}
    } 
});
const activeSku = ref({})

watch(
    () => props.activeSkuProduct,
    (newVal) => {
        activeSku.value = newVal
    },
    {
        immediate: true,
        deep: true
    }
)

const showEnergyLabel = computed(() => {
    const { energyLevel, energyLabel, repairabilityIcon, repairabilityLabel } = activeSku.value || {};
    return energyLevel || energyLabel || repairabilityIcon || repairabilityLabel;
});

const energyLabelConfig = computed(() => {
    const {
            energyLevel, 
            energyLevelFile,
            energyLevelAltText,
            energyLabel,
            energyLabelFile,

            repairabilityIcon,
            repairabilityIconFile,
            repairabilityIconAlt,
            repairabilityLabel,
            repairabilityLabelFile,

    } = activeSku.value || {};

    const list = [
        {
            showImg: energyLevel,
            imgFile: energyLevelFile,
            imgSrc: energyLevel,
            imgAlt: energyLevelAltText,
            imgHref: energyLevelFile,

            showLabel: energyLabel,
            labelHref: energyLabelFile,
            labelFile: energyLevelFile,
            labelText: energyLabel
        },
        {
            showImg: repairabilityIcon,
            imgFile: repairabilityIconFile,
            imgSrc: repairabilityIcon,
            imgAlt: repairabilityIconAlt,
            imgHref: repairabilityIconFile,

            showLabel: repairabilityLabel,
            labelHref: repairabilityLabelFile,
            labelFile: repairabilityLabelFile,
            labelText: repairabilityLabel
        }
    ]
    return list;
});
</script>

<template>
    <div class="csr-product-v1-energyLabel" v-if="showEnergyLabel">
        <div v-for="item in energyLabelConfig"
            :key="`${item.imgHref}${item.labelHref}`"
            :class="['csr-product-v1-energyLabel-item', (!item.showImg && !item.showLabel) && 'empty' ]"
        >
            <a v-if="item.showImg" :href="item.imgHref" target="_blank" class="csr-product-v1-energyLabel-item-iconbox">
                <img :class="[
                        { emptyFile: item.imgFile ? false : true },
                        'csr-product-v1-energyLabel-item-icon',
                    ]"
                    :src="item.imgSrc"
                    :alt="item.imgAlt" 
                />
            </a>
            <a v-if="item.showLabel" :href="item.labelHref" target="_blank"
                :class="[
                    { emptyFile: item.labelFile ? false : true },
                    'csr-product-v1-energyLabel-item-text',
                ]">
                {{ item?.labelText }}
            </a>
        </div>
    </div>
</template>